import React from 'react';
import { Stack } from '@mui/material';
import { IconPlayCircleSolid } from '@roku-web-ui/rds-icons';

interface BatteryTimeoutProps {
  connect: () => Promise<void>;
}

export const BatteryTimeout = ({ connect }: BatteryTimeoutProps) => (
  <Stack
    data-testid="camera-overlay-battery-timeout"
    direction="column"
    spacing={10}
    alignItems="center"
    justifyContent="center"
  >
    <IconPlayCircleSolid sx={{ fontSize: 90, cursor: 'pointer' }} onClick={() => connect()} />
  </Stack>
);
